import type { CSSProperties } from 'react'
import discordLogo from '../../products/discordlogo.png'

type DiscordIconProps = {
  size?: number
  className?: string
  style?: CSSProperties
  white?: boolean
  scale?: number
}

export function DiscordIcon({ size = 20, className, style, white = true, scale = 1 }: DiscordIconProps) {
  const renderSize = Math.round(size * Math.max(0.5, scale))

  return (
    <img
      src={discordLogo}
      alt=""
      aria-hidden="true"
      width={renderSize}
      height={renderSize}
      className={className}
      style={{
        objectFit: 'contain',
        filter: white ? 'brightness(0) invert(1) drop-shadow(0 0 8px rgba(255,255,255,0.32))' : undefined,
        ...style,
      }}
      draggable={false}
    />
  )
}
